<template>
  <DataListStateful
    title="Маршруты"
    resource="routes"
    :columns="columns"
    store="routes"
    :disable-adding="true"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "",
          name: "hasUnreadNotes",
          type: "icon",
          icon: "announcement",
          color: "green",
          tooltip: "Новый комментарий",
          sortable: false,
        },
        {
          title: "Ид",
          name: "id",
          dataPath: "Id",
          isEditLink: true,
          sortable: false,
        },
        { title: "Дата", name: "date", sortable: true },
        {
          title: "Номер маршрута",
          name: "number",
          width: "60",
          dataPath: "Title",
          sortable: true,
          maxLength: 8,
        },
        {
          title: "Статус",
          name: "state",
          dataPath: "State.Title",
          sortable: true,
        },
        {
          title: "Направление",
          name: "direction",
          dataPath: "Direction.Title",
          sortable: true,
        },
        {
          title: "Логист",
          name: "logist",
          dataPath: "Logist.Title",
          sortable: true,
        },
        {
          title: "Экспедиция",
          name: "forwarder",
          dataPath: "Forwarder.Title",
          sortable: true,
        },
        {
          title: "Перевозчик",
          name: "carrier",
          dataPath: "Carrier.Title",
          sortable: true,
        },
        {
          title: "Машина",
          name: "vehicle",
          dataPath: "Vehicle.Title",
          sortable: true,
        },
        {
          title: "Водитель",
          name: "driver",
          dataPath: "Driver.Title",
          sortable: true,
        },
        {
          title: "Дата начала погрузок",
          name: "loadingStartDate",
          width: "80",
          sortable: true,
        },
        {
          title: "Дата последней погрузки",
          name: "loadingLastDate",
          width: "100",
          sortable: true,
        },
        {
          title: "Планируемая дата затаможки",
          name: "customsRegistrationDatePlan",
          type: "date",
          width: "100",
          sortable: true,
        },
        {
          title: "Дата затаможки",
          name: "customsRegistrationDateFact",
          type: "date",
          width: "80",
          sortable: true,
        },
        {
          title: "Плановая дата прибытия на склад",
          name: "arriveToWarehouseDatePlan",
          type: "date",
          width: "120",
          sortable: true,
        },
        {
          title: "Фактическая дата прибытия на склад",
          name: "arriveToWarehouseDateFact",
          type: "date",
          width: "120",
          sortable: true,
        },
        {
          title: "Дата прибытия на место выгрузки",
          name: "arriveToUnloadingPlaceDate",
          width: "120",
          sortable: true,
        },
        {
          title: "Плановая дата прохождения границы",
          name: "passingBorderDatePlan",
          type: "date",
          width: "145",
          sortable: true,
        },
        {
          title: "Кол-во мест",
          name: "cargoPlaces",
          width: "50",
          sortable: true,
        },
        {
          title: "Вес брутто",
          name: "weightBrutto",
          width: "50",
          sortable: true,
        },
        { title: "Объем", name: "volume", sortable: true },
      ],
      filter: {
        date: {
          title: "Дата",
          type: "date",
        },
        routeStates: {
          title: "Статус погрузки",
          type: "enum",
          resource: "route-states",
        },
        route: {
          title: "Номер маршрута",
          type: "reference",
          resource: "routes",
        },
        prefix: {
          title: "Префикс маршрута",
          type: "text",
        },
        direction: {
          title: "Направление",
          type: "reference",
          resource: "countries",
        },
        forwarder: {
          title: "Экспедиция",
          type: "reference",
          resource: "forwarders",
        },
        carrier: {
          title: "Перевозчик",
          type: "reference",
          resource: "carriers",
        },
        vehicle: {
          title: "Машина",
          type: "reference",
          resource: "vehicles",
        },
        driver: {
          title: "Водитель",
          type: "reference",
          resource: "drivers",
        },
        loadingStartDate: {
          title: "Дата начала погрузок",
          type: "date",
        },
        loadingLastDate: {
          title: "Дата последней погрузки",
          type: "date",
        },
        customsRegistrationDatePlan: {
          title: "Планируемая дата затаможки",
          type: "date",
        },
        customsRegistrationDateFact: {
          title: "Дата затаможки",
          type: "date",
        },
        arriveToWarehouseDatePlan: {
          title: "Плановая дата прибытия на склад",
          type: "date",
        },
        arriveToWarehouseDateFact: {
          title: "Фактическая дата прибытия на склад",
          type: "date",
        },
        arriveToUnloadingPlaceDate: {
          title: "Дата прибытия на место выгрузки",
          type: "date",
        },
        passingBorderDatePlan: {
          title: "Плановая дата прохождения границы",
          type: "date",
        },
        cargoPlaces: {
          title: "Кол-во мест",
          type: "int",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
      },
    };
  },
};
</script>
